/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbPlageHoraireGridDto
 */
export interface FcbPlageHoraireGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbPlageHoraireGridDto
     */
    idplage?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbPlageHoraireGridDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the FcbPlageHoraireGridDto interface.
 */
export function instanceOfFcbPlageHoraireGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPlageHoraireGridDtoFromJSON(json: any): FcbPlageHoraireGridDto {
    return FcbPlageHoraireGridDtoFromJSONTyped(json, false);
}

export function FcbPlageHoraireGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPlageHoraireGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idplage': !exists(json, 'idplage') ? undefined : json['idplage'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function FcbPlageHoraireGridDtoToJSON(value?: FcbPlageHoraireGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idplage': value.idplage,
        'description': value.description,
    };
}

